module.exports = __webpack_public_path__ + "static/media/PCCLogin.a10059e8.svg";